import React, { memo } from "react";

const MonthlyYearlySwitch = memo(({ type, onChange }) => {
  return (
    <div className="switch-field input-shadow rounded">
      <input
        type="radio"
        id="radio-one"
        name="planExpirationType"
        value="monthly"
        checked={type === "monthly"}
        onChange={(e) => onChange(e)}
      />
      <label htmlFor="radio-one" className="f-bol f-12 rounded">
        Monthly
      </label>
      <input
        type="radio"
        id="radio-two"
        name="planExpirationType"
        value="yearly"
        checked={type === "yearly"}
        onChange={(e) => onChange(e)}
      />
      <label htmlFor="radio-two" className="f-bol f-12 rounded">
        Yearly
      </label>
    </div>
  );
});

export default MonthlyYearlySwitch;
